import { type ExternalDocument } from '@atlassian/search-client/recommended-documents/types';

import type { EnrichedRecommendedDocument } from '../../../../common/ui/quick-find/types';

export const isExternalDocumentRecommendation = (
	result: EnrichedRecommendedDocument,
): result is EnrichedRecommendedDocument & { object: ExternalDocument } => {
	return result?.object?.__typename === 'ExternalDocument';
};
